<template>
  <div>
    <form @submit.prevent="submitForm" class="ui-form" method="POST">
      <div class="row signup__columns mt-md-4 mt-0">
        <div class="col-xl-6 col-12" data-wronged="">
          <div class="signup__input-wrapper">
            <the-mask
              aria-label="Telefone"
              name="code"
              id="code"
              :masked="true"
              :mask="['AX-A#A#-##']"
              v-model="form.code"
              required
            />
            <label for="code"> Código do Passaporte* </label>
          </div>
        </div>
        <div class="col-xl-6 col-12 d-flex justify-content-start" v-if="disabled">
          <button
            @click="validateCheckIn"
            :disabled="disabled_button_check"
            class="ui-button--verde"
            type="button"
          >
            <i class="fa fa-spinner fa-pulse" v-if="disabled_button_check"></i>
            VALIDAR CHECK-IN
          </button>
        </div>
        <div class="col-xl-6 col-12 d-flex justify-content-start" v-if="!disabled"></div>
        <div class="col-xl-6 col-12" data-wronged="" v-if="!disabled">
          <div class="signup__input-wrapper">
            <input type="text" name="name" id="name" v-model="form.name" maxlength="255" required />
            <label for="name"> Nome Completo* </label>
          </div>
        </div>
        <div class="col-xl-6 col-12" data-wronged="" v-if="!disabled">
          <div class="signup__input-wrapper">
            <the-mask
              aria-label="Telefone"
              name="phone"
              id="phone"
              :masked="true"
              :mask="['(##) ####-####', '(##) #####-####']"
              v-model="form.phone"
              required
            />
            <label for="phone"> Telefone* </label>
          </div>
        </div>
        <div class="col-xl-6 col-12" data-wronged="" v-if="!disabled">
          <div class="signup__input-wrapper">
            <input type="email" id="email" v-model="form.email" maxlength="255" required />
            <label for="email"> E-mail* </label>
          </div>
        </div>
        <div class="col-xl-6 col-md-12 col-sm-6 col-12" data-wronged="" v-if="!disabled">
          <div class="signup__input-wrapper">
            <the-mask
              aria-label="CPF"
              name="cpf"
              id="cpf"
              :masked="true"
              :mask="['###.###.###-##']"
              v-model="form.cpf"
              required
            />
            <label for="cpf"> CPF* </label>
          </div>
        </div>
        <div class="col-xl-6 col-md-12 col-sm-6 col-12" data-wronged="" v-if="!disabled">
          <div class="signup__input-wrapper">
            <select id="state" v-model="form.state" v-on:change="changesState()" required>
              <option disabled selected>Por favor, selecione um estado</option>
              <option v-for="(item, index) in locations.estados" :key="index" :value="item.nome">
                {{ item.nome }}
              </option>
            </select>
            <label for="state"> Estado* </label>
          </div>
        </div>
        <div class="col-xl-6 col-md-12 col-sm-6 col-12" data-wronged="" v-if="!disabled">
          <div class="signup__input-wrapper">
            <select id="city" v-model="form.city" required>
              <option disabled selected>Por favor, selecione uma cidade</option>
              <option v-for="(item, index) in cities" :key="index" :value="item">
                {{ item }}
              </option>
            </select>
            <label for="city"> Cidade* </label>
          </div>
        </div>
        <div class="col-xl-6 col-md-12 col-sm-6 col-12" data-wronged="" v-if="!disabled">
          <div class="signup__input-wrapper">
            <select id="schooling" v-model="form.schooling" required>
              <option disabled selected>Por favor, selecione uma opção</option>
              <option v-for="(item, index) in schooling" :key="index" :value="item">
                {{ item }}
              </option>
            </select>
            <label for="schooling"> Escolaridade* </label>
          </div>
        </div>
        <div class="col-xl-6 col-md-12 col-sm-6 col-12" data-wronged="" v-if="!disabled">
          <div class="signup__input-wrapper">
            <select id="gender" v-model="form.gender" required>
              <option disabled selected>Por favor, selecione uma opção</option>
              <option value="masculino">Masculino</option>
              <option value="feminino">Feminino</option>
              <option value="outro">Outro</option>
            </select>
            <label for="gender"> Gênero* </label>
          </div>
        </div>
        <div class="col-xl-6 col-lg-12 col-md-6 col-12" data-wronged="" v-if="!disabled">
          <div class="signup__input-wrapper">
            <the-mask
              aria-label="CPF"
              name="birthday"
              id="birthday"
              :masked="true"
              :mask="['##/##/####']"
              v-model="form.birthday"
              required
            />
            <label for="birthday"> Data de nascimento* </label>
          </div>
        </div>
        <div class="col-xl-6 col-md-12 col-sm-6 col-12" v-if="!disabled"></div>
        <div
          class="col-xl-6 col-md-12 col-sm-6 col-12"
          v-if="!disabled && day_pass_dates.length > 0"
        >
          <span>
            Você tem um dia todo para passar com a gente lá no evento! A única coisa que eu preciso
            saber é qual dia vai ser esse. Por favor, selecione um dos dias do evento.
          </span>
        </div>
        <div
          class="col-xl-6 col-md-12 col-sm-6 col-12"
          v-if="!disabled && day_pass_dates.length > 0"
        >
          <div class="signup__input-wrapper">
            <select id="day_pass_date" v-model="form.day_pass_date" required>
              <option disabled selected>Por favor, selecione um dia</option>
              <option :key="date.date" :value="date.date" v-for="date in day_pass_dates">
                {{ date.formatted_date }}
              </option>
            </select>
            <label for="day_pass_date"> Dia do evento* </label>
          </div>
        </div>
        <div
          class="col-xl-6 col-12 d-flex flex-md-row flex-column justify-content-md-center justify-content-start"
          data-wronged=""
          v-if="!disabled"
        >
          <label for="works-0" class="signup__radio--simpler">
            <input
              type="radio"
              id="works-0"
              name="works"
              value="0"
              v-model="form.works"
              @click="uncheck(0)"
            />
            <span></span>
            Sou Produtor Rural
          </label>
          <label for="works-1" class="signup__radio--simpler mx-md-2">
            <input
              type="radio"
              id="works-1"
              name="works"
              value="1"
              v-model="form.works"
              @click="uncheck(1)"
            />
            <span></span>
            Sou Autônomo
          </label>
          <label for="works-2" class="signup__radio--simpler">
            <input
              type="radio"
              id="works-2"
              name="works"
              value="2"
              v-model="form.works"
              @click="uncheck(2)"
            />
            <span></span>
            Não trabalho
          </label>
        </div>
        <div class="col-xl-6 col-12" data-wronged="" v-if="!disabled">
          <div class="signup__input-wrapper" :data-loading="cnpj_loading">
            <the-mask
              aria-label="CNPJ"
              name="cnpj"
              id="cnpj"
              :masked="true"
              :mask="['##.###.###/####-##']"
              :required="!form.works"
              v-model="form.cnpj"
              :disabled="cnpj_loading"
            />
            <span>
              <i class="fa fa-spinner fa-pulse"></i>
            </span>
            <label for="cnpj">
              CNPJ da empresa onde você trabalha{{ !form.works ? '*' : '' }}
            </label>
          </div>
        </div>
        <div class="col-xl-6 col-12" data-wronged="" v-if="!disabled">
          <div class="signup__input-wrapper">
            <input
              type="text"
              id="company"
              v-model="form.company"
              :required="form.works ? false : true"
            />
            <label for="company"> Empresa{{ !form.works ? '*' : '' }} </label>
          </div>
        </div>
        <div class="col-xl-6 col-12" data-wronged="" v-if="!disabled">
          <div class="signup__input-wrapper">
            <input
              type="text"
              id="position"
              v-model="form.position"
              :required="form.works ? false : true"
            />
            <label for="position"> Cargo{{ !form.works ? '*' : '' }} </label>
          </div>
        </div>
        <div class="col-xl-6 col-12" data-wronged="" v-if="!disabled && !form.works">
          <div class="signup__input-wrapper">
            <select id="company_invoicing" v-model="form.company_invoicing">
              <option disabled selected>Por favor, selecione uma opção</option>
              <option value="1">Ainda não faturamos</option>
              <option value="2">Até R$500 mil ao ano</option>
              <option value="3">De R$500 mil a R$1 milhão ao ano</option>
              <option value="4">De R$1 milhão a R$5 milhões ao ano</option>
              <option value="5">De R$5 a R$10 milhões ao ano</option>
              <option value="6">De R$10 a R$50 milhões ao ano</option>
              <option value="7">De R$50 a R$500 milhões ao ano</option>
              <option value="8">Acima de R$500 milhões ao ano</option>
            </select>
            <label for="company_invoicing"> Faturamento atual da empresa</label>
          </div>
        </div>
        <div class="col-xl-6 col-12" data-wronged="" v-if="!disabled && !form.works">
          <div class="signup__input-wrapper">
            <select id="company_collaborators" v-model="form.company_collaborators">
              <option disabled selected>Por favor, selecione uma opção</option>
              <option value="1">Até 10 colaboradores</option>
              <option value="2">De 10 a 50 colaboradores</option>
              <option value="3">De 51 a 100 colaboradores</option>
              <option value="4">De 101 a 1.000 colaboradores</option>
              <option value="5">Acima de 1.000 colaboradores</option>
            </select>
            <label for="company_collaborators"> Faixa de funcionários</label>
          </div>
        </div>
        <div class="col-12 justify-content-start" v-if="!disabled">
          <div class="checkin-checkbox">
            <input type="checkbox" id="check1" v-model="form.check1" />
            <label for="check1" class="mb-0">
              Autorizo a coleta de meus dados pessoais solicitados no momento em que realizo meu
              check-in no Evento. Esses dados são importantes para evitarmos eventuais fraudes e
              para conseguirmos entregar uma melhor experiência ao participante. Para mais
              informações acesse nossa política de privacidade.
            </label>
          </div>
        </div>
        <div class="col-12 justify-content-start" v-if="!disabled">
          <div class="checkin-checkbox">
            <input type="checkbox" id="check2" v-model="form.check2" />
            <label for="check2" class="mb-0">
              Autorizo o uso e tratamento de minha imagem que poderá ser divulgada em redes sociais
              e plataformas de streaming por um período de até 5 anos. Para mais informações acesse
              nossa política de privacidade .
            </label>
          </div>
        </div>
        <div class="col-12 justify-content-start" v-if="!disabled">
          <div class="checkin-checkbox">
            <input type="checkbox" id="check3" v-model="form.check3" />
            <label for="check3" class="mb-0">
              Autorizo receber conteúdos de parceiros e patrocinadores do Evento antes, durante e
              após o HJ Conference. Para mais informações acesse nossa política de privacidade.
            </label>
          </div>
        </div>
        <div class="col-12 justify-content-start" v-if="!disabled">
          <div class="checkin-checkbox">
            <input type="checkbox" id="check4" v-model="form.check4" required />
            <label for="check4" class="mb-0">
              Li e concordo com as
              <a
                class="checkin__privacy-policy"
                :href="privacy_policy"
                rel="noreferrer"
                target="_blank"
              >
                políticas de privacidade e termos de uso.
              </a>
            </label>
          </div>
        </div>
      </div>
      <div class="row" v-if="!disabled">
        <div class="col-xl-3 col-lg-4 col-md-5 col-12">
          <button
            type="submit"
            :class="'ui-button--' +
              (form.check1 && form.check2 && form.check3 && form.check4 ? 'green' : 'grey')
              "
            id="submit-button"
          >
            {{ button }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios'
import locations from './locations/city.json?v=2'
import LogHelper from './Helpers/LogHelper'
import consultarCNPJ from 'consultar-cnpj'

export default {
  props: ['checkin', 'check_passports', 'p_code', 'privacy_policy'],
  data() {
    return {
      form: {
        name: '',
        email: '',
        phone: '',
        cpf: '',
        state: '',
        city: '',
        schooling: '',
        works: null,
        cnpj: '',
        position: '',
        company: '',
        code: this.p_code,
        gender: '',
        company_invoicing: '',
        company_collaborators: '',
        birthday: '',
        check1: true,
        check2: true,
        check3: true,
        check4: 0,
        day_pass_date: '',
      },
      cnpj_loading: false,
      disabled_button_check: false,
      button: 'Fazer Check-in',
      disabled: true,
      locations: locations,
      day_pass_dates: [],
      cities: '',
      block: false,
      previouslySelected: null,
      schooling: [
        'Fundamental',
        'Ensino Médio',
        'Graduando',
        'Graduado',
        'Pós-Graduando',
        'Pós-Graduado',
        'Mestrando',
        'Mestrado',
        'Doutorando',
        'Doutorado',
        'Pós-Doutorando',
        'Pós-Doutorado',
        'Outro',
      ],
    }
  },
  mounted() {
    if (this.p_code) {
      axios.post(this.check_passports, { code: this.form.code.toUpperCase() }).then((response) => {
        if (response.data.error) {
          var code = document.getElementById('code')
          code.parentElement.classList.remove('ui-correct')
          this.assignError(code, response.data.error)
        } else if (!response.data) {
          var code = document.getElementById('code')
          code.parentElement.classList.remove('ui-correct')
          this.assignError(code, 'Esse passaporte não existe')
        } else {
          if (response?.data?.day_pass_dates) {
            this.day_pass_dates = response.data.day_pass_dates
          }
          var code = document.getElementById('code')
          code.parentElement.classList.remove('ui-wronged')
          code.parentElement.dataset.wronged =
            'Você está quase lá :). Só preencher os campos abaixo.'
          code.parentElement.classList.add('ui-correct')
          this.disabled = false
        }
      })
    }
  },
  watch: {
    'form.code': function () {
      if (this.form.code.length <= 9 || !!this.form.code) {
        this.disabled = true
        var code = document.getElementById('code')
        code.parentElement.classList.remove('ui-correct')
        code.parentElement.classList.remove('ui-wronged')
      }
    },
    async 'form.cnpj'(value) {
      if (value.length == 18) {
        await this.validateCNPJ()
      } else {
        document.getElementById('cnpj').parentElement.classList.remove('ui-wronged')
      }
    },
  },
  methods: {
    uncheck(value) {
      this.previouslySelected = this.form.works
      if (this.previouslySelected == value) {
        this.form.works = null
      }
      if (this.form.cnpj !== '') {
        this.validateCNPJ()
      }
    },
    async validateCNPJ() {
      /*if (this.form.cnpj) {
         let is_valid
         this.cnpj_loading = true
         document.getElementById('cnpj').parentElement.classList.remove('ui-correct')
         try {
           const response = await consultarCNPJ(
             this.form.cnpj.replaceAll('/', '').replaceAll('.', '').replaceAll('-', ''),
             process.env.MIX_CNPJ_KEY
           )
 
           const cnpj = document.getElementById('cnpj')
           if (this.form.company === '') {
             this.form.company = response?.estabelecimento?.nome_fantasia
           }
           cnpj.parentElement.dataset.wronged = 'CNPJ válido :)'
           cnpj.parentElement.classList.add('ui-correct')
           is_valid = true
         } catch (error) {
           const cnpj = document.getElementById('cnpj')
           if (error.status == 400) {
             this.assignError(cnpj, error.detalhes)
           } else if (error.status == 404) {
             this.assignError(cnpj, 'CNPJ não econtrado. Por favor, tente novamente com outro CNPJ.')
           } else {
             // Este erro genérico aparece somente nos casos em que houver um problema mas que não é uma requisição inválida: https://www.cnpj.ws/docs/modelos-dados/mensagens-erro
             this.$swal({
               allowOutsideClick: false,
               closeOnClickOutside: false,
               title: 'Oops :|',
               html: 'Tivemos algum problema ao pesquisar sua empresa. Por favor, preencha o cnpj novamente e caso aconteça novamente, marque o campo "Não trabalho"',
               confirmButtonText: 'Ok',
               confirmButtonColor: '#DF1949',
             })
           }
           is_valid = false
         }
         this.cnpj_loading = false
         return is_valid
       } else {
         return true
       }*/
      return true;
    },
    async validateCheckIn() {
      this.disabled_button_check = true
      if (this.form.code.length >= 9) {
        await axios.post(this.check_passports, { code: this.form.code }).then((response) => {
          if (response.data.error) {
            var code = document.getElementById('code')
            code.parentElement.classList.remove('ui-correct')
            this.$swal({
              allowOutsideClick: false,
              closeOnClickOutside: false,
              type: "warning",
              html: response.data.error,
              confirmButtonText: 'Ok',
              confirmButtonColor: '#DF1949',
            })
            this.disabled = true
            LogHelper.sendLogToGoogleChat(`Formulário de Check-In | ${response.data.error}`, 406)
          } else if (!response.data) {
            var code = document.getElementById('code')
            const message = 'Esse passaporte não existe'
            code.parentElement.classList.remove('ui-correct')
            this.assignError(code, message)
            this.disabled = true
            LogHelper.sendLogToGoogleChat(`Formulário de Check-In | ${message}`, 406)
          } else {
            if (response?.data?.day_pass_dates) {
              this.day_pass_dates = response.data.day_pass_dates
            }
            var code = document.getElementById('code')
            code.parentElement.classList.remove('ui-wronged')
            code.parentElement.dataset.wronged =
              'Você está quase lá :). Só preencher os campos abaixo.'
            code.parentElement.classList.add('ui-correct')
            this.disabled = false
          }
        })
      } else {
        var code = document.getElementById('code')
        const message = 'Insira o código do seu passaporte no campo.'
        code.parentElement.classList.remove('ui-correct')
        this.assignError(code, message)
        this.disabled = true
      }
      this.disabled_button_check = false
    },
    resetForm() {
      this.form = {
        name: '',
        email: '',
        phone: '',
        cpf: '',
        state: '',
        city: '',
        schooling: '',
        works: false,
        cnpj: '',
        position: '',
        company: '',
        code: '',
        gender: '',
        company_invoicing: '',
        company_collaborators: '',
        birthday: '',
        day_pass_date: '',
      }
    },
    removeErrorMessages() {
      //Removes all error messages from the inputs
      var items = document.getElementsByClassName('ui-wronged')
      for (var i = items.length - 1; i >= 0; i--) {
        items[items.length - 1].classList.remove('ui-wronged')
      }
    },
    async submitForm() {
      let is_form_ok = this.isFormOk()
      if (is_form_ok && (await this.validateCNPJ())) {
        this.button = 'Fazendo checkin...'
        var submit_button = document.getElementById('submit-button')
        submit_button.disabled = true
        this.removeErrorMessages()
        const sleepingPromise = (delay) => new Promise((resolve) => setTimeout(resolve, delay))
        const sleep = async () => {
          await sleepingPromise(1000)
          axios
            .post(this.checkin, {
              client: this.form,
              address: this.address,
            })
            .then((response) => {
              this.$swal({
                title: 'Check-in feito com sucesso 🚀',
                html:
                  'Deu certo! Guarde o código do seu passaporte: <br/><strong>' +
                  this.form.code +
                  '.</strong><br/> Ele será seu acesso ao evento. Você também receberá um e-mail de confirmação.',
                confirmButtonText: 'Ok',
                confirmButtonColor: '#28a745',
                closeOnClickOutside: true,
                allowOutsideClick: false,
                closeOnClickOutside: false,
                allowEscapeKey: false,
              }).then((confirm) => {
                if (confirm.value) {
                  location.href = '/cliente/checkin'
                }
              })
            })
            .catch((e) => {
              this.button = 'Fazer Check-in'
              var submit_button = document.getElementById('submit-button')
              submit_button.disabled = false
              this.$swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                title: 'Oops :|',
                html: e.response.data.error,
                confirmButtonText: 'Ok',
                confirmButtonColor: '#DF1949',
              })
            })
        }
        sleep()
      }
    },
    isFormOk() {
      this.removeErrorMessages()
      var is_ok = true

      //Checks if the name has more than two words if it's a PF
      var name = document.getElementById('name')
      if (!(name.value.indexOf(' ') >= 0)) {
        const message = 'Digite nome e sobrenome, por favor'
        this.assignError(name, message)
        is_ok = false
        LogHelper.sendLogToGoogleChat(`Formulário de Check-In | ${message}`, 406)
      }

      //Checks if the CPF is a valid one
      var cpf = document.getElementById('cpf')
      if (!this.checkCPF(cpf.value)) {
        const message = 'Digite um CPF válido, por favor'
        this.assignError(cpf, message)
        is_ok = false
        LogHelper.sendLogToGoogleChat(`Formulário de Check-In | ${message}`, 406)
      }

      //Checks if the birthday date is complete
      var birthday_date = document.getElementById('birthday')
      if (birthday_date.value.length < 10) {
        const message = 'Digite uma data válida, por favor'
        this.assignError(birthday_date, message)
        is_ok = false
        LogHelper.sendLogToGoogleChat(`Formulário de Check-In | ${message}`, 406)
      }
      if (birthday_date.value.split('/')[2] == '2021') {
        const message = 'Digite um ano válido, por favor'
        this.assignError(birthday_date, message)
        is_ok = false
        LogHelper.sendLogToGoogleChat(`Formulário de Check-In | ${message}`, 406)
      }

      //Checks if all the fields are filled
      var items = [
        'name',
        'email',
        'phone',
        'cpf',
        'state',
        'city',
        'schooling',
        'code',
        'birthday',
      ]

      if (this?.day_pass_dates.length > 0) {
        items.push('day_pass_date')
      }

      if (!this.form.works) {
        items.push('cnpj')
      }

      for (var i = 0; i < items.length; i++) {
        var element = document.getElementById(items[i])
        if (element.value.length < 1) {
          const message = 'Este campo é obrigatório'
          this.assignError(element, message)
          is_ok = false
          LogHelper.sendLogToGoogleChat(`Formulário de Check-In (${items[i]}) | ${message}`, 406)
        }
      }

      for (const check of ['check4']) {
        var element = document.getElementById(check)
        if (!element.checked) {
          const message = 'Este campo é obrigatório'
          element.parentElement.classList.add('ui-wronged')
          is_ok = false
          LogHelper.sendLogToGoogleChat(`Formulário de Check-In (${check}) | ${message}`, 406)
        }
      }

      return is_ok
    },
    assignError(element, message) {
      //Assign an error message
      element.parentElement.dataset.wronged = message
      element.parentElement.classList.add('ui-wronged')
    },
    changesState() {
      //Changes the cities available to correspond with the selceted state
      for (var i = 0; i < this.locations.estados.length; i++) {
        if (this.locations.estados[i].nome == this.form.state) {
          this.cities = this.locations.estados[i].cidades
        }
      }
    },
    checkCPF(cpf) {
      //Separates the numbers before and after the '-'
      var cpf = cpf.replaceAll('.', '')
      var cpf = cpf.replaceAll('-', '')

      if (/^0*$/.test(cpf)) {
        return false
      }

      var cpf_validation = cpf.slice(9, 12)
      var cpf_operation = cpf.slice(0, 9)

      //Sums each number before the '-' multiplied by (10..2)
      var sum = 0
      for (var i = 10; i >= 2; i--) {
        sum += +cpf_operation[10 - i] * i
      }

      //Get the rest of the sum, if it's 11 or 10, it'll be zero
      var rest = (sum * 10) % 11
      if (rest == 10 || rest == 11) {
        rest = 0
      }

      //If the rest is different from the first digit, it's already invalid
      if (rest != +cpf_validation[0]) {
        return false
      }

      //Repeat for the next digit of validation
      var cpf_validation = cpf.slice(10, 12)
      var cpf_operation = cpf.slice(0, 11)

      //Sums each number before the last digit multiplied by (11..2)
      var sum = 0
      for (var i = 11; i >= 2; i--) {
        sum += +cpf_operation[11 - i] * i
      }

      //Get the rest of the sum, if it's 11 or 10, it'll be zero
      var rest = (sum * 10) % 11
      if (rest == 10 || rest == 11) {
        rest = 0
      }

      //If the rest is different from the first digit, it's already invalid
      if (rest != +cpf_validation[0]) {
        return false
      } else {
        return true
      }
    },
  },
}
</script>
